import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";


export class FeedbackAPIHandler {
    
    public static shared = new FeedbackAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async postCategorySuggestion(categorySuggestionData: any): Promise<boolean> {
        let url = this.serverConfig.feedbackAPIs.createCategorySuggestionAPI;
        let headers = this.networkUtils.addCommonHeaders({});

        try {
            
            await this.apiHandler.makePostRequest(headers, url, {...categorySuggestionData});
            return Promise.resolve(true);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async postGGReview(ggReviewData: any): Promise<boolean> {
        let url = this.serverConfig.feedbackAPIs.createGGReviewAPI;
        let headers = this.networkUtils.addCommonHeaders({});

        try {
            
            await this.apiHandler.makePostRequest(headers, url, {...ggReviewData});
            return Promise.resolve(true);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async writeToUsFeedback(feedbackData: any): Promise<true> {
        let url = this.serverConfig.feedbackAPIs.createWriteToUsFeedbackAPI;
        let headers = this.networkUtils.addCommonHeaders({});

        try {
            
            await this.apiHandler.makePostRequest(headers, url, {...feedbackData});
            return Promise.resolve(true);

        } catch (err) {
            return Promise.reject(err);
        }
  }
}